import React, { useState } from 'react';
import { projectsData } from '../mock';

export const Projects = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [hoveredProject, setHoveredProject] = useState(null);

  const categories = ['All', 'Commercial', 'Residential', 'Industrial', 'Modern Façades'];

  const filteredProjects = selectedCategory === 'All'
    ? projectsData
    : projectsData.filter(project => project.category === selectedCategory);

  return (
    <section id="projects" className="relative py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm tracking-[0.3em] uppercase text-gray-500 font-light">
              Our Portfolio
            </span>
            <div className="h-px w-16 bg-gray-900 mt-2 mx-auto" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-6">
            Showcase of Excellence
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-12">
            Explore our curated collection of architectural glazing masterpieces
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full text-sm tracking-wide transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-gray-900 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              onMouseEnter={() => setHoveredProject(project.id)}
              onMouseLeave={() => setHoveredProject(null)}
              className="group relative aspect-[3/4] rounded-lg overflow-hidden cursor-pointer shadow-md hover:shadow-2xl transition-all duration-500"
            >
              {/* Image */}
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              {/* Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent transition-opacity duration-500 ${
                hoveredProject === project.id ? 'opacity-100' : 'opacity-80'
              }`} />

              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                {/* Category Badge */}
                <div className="mb-3">
                  <span className="inline-block px-3 py-1 text-xs tracking-wider uppercase bg-white/20 backdrop-blur-md text-white rounded-full border border-white/30">
                    {project.category}
                  </span>
                </div>

                {/* Title */}
                <h3 className="text-xl font-medium text-white leading-tight transition-transform duration-500 group-hover:translate-y-0 translate-y-2">
                  {project.title}
                </h3>

                {/* View Details - appears on hover */}
                <div className={`mt-3 flex items-center gap-2 text-white text-sm transition-all duration-500 ${
                  hoveredProject === project.id
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-4'
                }`}>
                  <span>View Details</span>
                  <div className="h-px flex-1 bg-white/50" />
                </div>
              </div>

              {/* Glass Reflection Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br from-white/20 to-transparent transition-opacity duration-700 ${
                hoveredProject === project.id ? 'opacity-100' : 'opacity-0'
              }`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};